"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Composition_Section = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_code_1 = require("../Scalar/RTTI_code");
exports.RTTI_Composition_Section = t.recursion('IComposition_Section', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        title: t.string,
        _title: RTTI_Element_1.RTTI_Element,
        code: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        author: t.array(RTTI_Reference_1.RTTI_Reference),
        focus: RTTI_Reference_1.RTTI_Reference,
        text: RTTI_Narrative_1.RTTI_Narrative,
        mode: RTTI_code_1.RTTI_code,
        _mode: RTTI_Element_1.RTTI_Element,
        orderedBy: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        entry: t.array(RTTI_Reference_1.RTTI_Reference),
        emptyReason: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        section: t.array(exports.RTTI_Composition_Section)
    });
});
//# sourceMappingURL=RTTI_Composition_Section.js.map